import React from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import { AppPathList } from 'router/AppPathList';
import { ModalWrapper } from './ModalWrapper';
import { Button } from '../base';
import { activeModuleSelector } from '../../modules/survey/selectors';

export const GoBackErrorModal = () => {
	const { t } = useTranslation('common');
	const { t: te } = useTranslation('errors');
	const activeModule = useSelector(activeModuleSelector);

	return (
		<ModalWrapper type="result" contentWrapperClass="go-back-modal">
			<HighlightOffIcon className="modal-icon-fail" />
			<h2 className="modal-result__title">{t('modals.fail')}</h2>
			<p className="modal-result__text">{te('can_not_go_back')}</p>
			<Button
				buttonText="Ok"
				buttonClass="modal-result__btn"
				to={`${AppPathList.survey}/module/${activeModule}`}
			/>
		</ModalWrapper>
	);
};
